import { CREATE_FORM_STATE, CREATE_FORM_STATE_ASYNC, DELETE_FORM_STATE, DELETE_FORM_STATE_ASYNC, UPDATE_FORM_STATE, UPDATE_FORM_STATE_ASYNC } from './forms.action-types';
export var actions = {
  /**
   * create form async action.
   *
   * @author Mikhail Siutsou
   * @function createFormAsync
   * @category Actions
   */
  createFormAsync: function createFormAsync(payload) {
    return {
      type: CREATE_FORM_STATE_ASYNC,
      payload: payload
    };
  },

  /**
   * create form action.
   *
   * @author Mikhail Siutsou
   * @function createForm
   * @category Actions
   */
  createForm: function createForm(payload) {
    return {
      type: CREATE_FORM_STATE,
      payload: payload
    };
  },

  /**
   * update form async action.
   *
   * @author Mikhail Siutsou
   * @function updateFormStateAsync
   * @category Actions
   */
  updateFormStateAsync: function updateFormStateAsync(payload) {
    return {
      type: UPDATE_FORM_STATE_ASYNC,
      payload: payload
    };
  },

  /**
   * update form action.
   *
   * @author Mikhail Siutsou
   * @function updateFormState
   * @category Actions
   */
  updateFormState: function updateFormState(payload) {
    return {
      type: UPDATE_FORM_STATE,
      payload: payload
    };
  },

  /**
   * delete form async action.
   *
   * @author Mikhail Siutsou
   * @function deleteFormStateAsync
   * @category Actions
   */
  deleteFormStateAsync: function deleteFormStateAsync(payload) {
    return {
      type: DELETE_FORM_STATE_ASYNC,
      payload: payload
    };
  },

  /**
   * delete form action.
   *
   * @author Mikhail Siutsou
   * @function deleteFormState
   * @category Actions
   */
  deleteFormState: function deleteFormState(payload) {
    return {
      type: DELETE_FORM_STATE,
      payload: payload
    };
  }
};